import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => {
  return {
    root: { height: 46 },
    textField: { margin: 0 },
  };
});
